function buildIconZoomScaleExpression(zoomStops) {
  return [
    "interpolate",
    ["linear"],
    ["zoom"],
    ...zoomStops.flat(),
    14,
    1,
    22,
    1,
  ];
}

export const stopIconSizeExpression = buildIconZoomScaleExpression([
  [0, 0.2],
  [10, 0.2],
  [12, 0.72],
  [13, 0.9],
]);

export const activeStopIconSizeExpression = buildIconZoomScaleExpression([
  [10, 0.2],
  [12, 0.76],
  [13, 0.93],
]);

export const scooterIconSizeExpression = buildIconZoomScaleExpression([
  [10, 0.8],
  [13, 0.92],
]);

export const selectedScooterIconSizeExpression = scooterIconSizeExpression;

export const searchLocationIconSizeExpression = buildIconZoomScaleExpression([
  [5, 0.3],
  [10, 0.42],
  [13, 0.82],
]);

export function buildTripMapStopIconSizeExpression(selectedStopId) {
  return [
    "interpolate",
    ["linear"],
    ["zoom"],
    10,
    ["case", ["==", ["get", "stop_id"], selectedStopId ?? null], 0.3, 0.2],
    12,
    ["case", ["==", ["get", "stop_id"], selectedStopId ?? null], 0.8, 0.72],
    13,
    ["case", ["==", ["get", "stop_id"], selectedStopId ?? null], 0.94, 0.9],
    14,
    1,
    22,
    1,
  ];
}
